import { SelectOptionType } from '../../../utils/react-table';

type JobTitleDto = {
    id?: number | null;
    name: string;
};

export const mapJobTitlesToSelectOption = (jobTitles: Array<JobTitleDto>): Array<SelectOptionType> => {
    return jobTitles.map((title) => ({ value: title.id ?? 0, label: title.name }));
};

export default JobTitleDto;
